import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Typography } from "@mui/material"

export default function BFInput({ label, text, name, important, onChange, error, description }) {
  return (
    <FormControl sx={{ mb: -1 }} error={!!error} required={!!important}>
      <FormLabel sx={{ fontWeight: "bold" }}>{label}</FormLabel>
      {description?.map((paragraph, i) => (
        <Typography key={i} variant="body2" sx={{ ml: 1, mt: i === 0 ? 1 : 0.5, color: "text.secondary" }}>
          {paragraph}
        </Typography>
      ))}
      <FormControlLabel
        label={text}
        sx={{ ml: 1, mt: description?.length ? 1 : 0 }}
        control={<Checkbox onChange={onChange} name={name} value={"ok"} />}
      />

      <FormHelperText color={"error"} sx={{ mt: -1 }}>
        {error ?? " "}
      </FormHelperText>
    </FormControl>
  )
}
